import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import HelpText from './helpers/HelpText';
import FieldError from './helpers/FieldError';
import PlaceholderSelector from './PlaceholderSelector';
import i18n from '../../../i18n';


const CkEditor = ( { 
    fieldName, 
    label, 
    input_type, 
    helpText,
    onChange = () => { },
    allowNull = true, 
    value, 
    required, 
    placeholder, 
    disabled, 
    wrapperClass, 
    inputClass, 
    errors, 
    choices,
    placeholders =[],
    // [
    //     { key: 'customer_name', label: 'Customer Name' },
    //     { key: 'company_name', label: 'Company Name' },
    //     { key: 'company', label: 'Company', children: [
    //         { key: 'name', label: 'Name' }, 
    //         { key: 'email', label: 'Email' }, 
    //         { key: 'phone', label: 'Phone' }, 
    //         { key: 'address', label: 'Address' }, 
    //         { key: 'city', label: 'City' }, 
    //         { key: 'state', label: 'State' }, 
    //         { key: 'zip', label: 'Zip' }
    //     ] },
    //     { key: 'email', label: 'Email Address' },
    //     { key: 'phone', label: 'Phone Number' },
    //     { key: 'date', label: 'Date' },
    //     { key: 'amount', label: 'Amount' },
    //     { key: 'product_name', label: 'Product Name' },
    //     { key: 'order_id', label: 'Order ID' },
    //     { key: 'other_contacts', label: 'Other Contacts', list: true, 
    //         children:[
    //             { key: 'name', label: 'Name' },
    //             { key: 'email', label: 'Email' },
    //             { key: 'phone', label: 'Phone' },
    //             { key: 'address', label: 'Address' },
    //             { key: 'city', label: 'City' },
    //             { key: 'state', label: 'State' },
    //             { key: 'zip', label: 'Zip' },
    //             { key: 'company', label: 'Company', 
    //                 children: [
    //                     { key: 'name', label: 'Name' }, 
    //                     { key: 'email', label: 'Email' }, 
    //                     { key: 'phone', label: 'Phone' }, 
    //                     { key: 'address', label: 'Address' }, 
    //                     { key: 'city', label: 'City' }, 
    //                     { key: 'state', label: 'State' }, 
    //                     { key: 'zip', label: 'Zip' }
    //                 ] 
    //             },
    //         ] },
    // ],
    pk = null
}) => {
    const [editorInstance, setEditorInstance] = useState(null);
    const [validationMessage, setValidationMessage] = useState('');

    const localOnChange = (event, editor) => {
        onChange({'name':fieldName, 'value': editor.getData(), 'label': editor.getData()})
    }
    const insertPlaceholder = (placeholderPath) => {
        if (editorInstance) {
            // Check if this is a Django template loop (contains {% for %})
            if (placeholderPath.includes('{% for')) {
                // For Django template loops, insert the full template code
                editorInstance.model.change(writer => {
                    const selection = editorInstance.model.document.selection;
                    const range = selection.getFirstRange();
                    writer.insertText(placeholderPath, range.start);
                });
            } else {
                // Validate loop variables
                const validation = validateLoopVariable(`{${placeholderPath}}`, editorInstance.getData());
                if (!validation.valid) {
                    setValidationMessage(validation.message);
                    setTimeout(() => setValidationMessage(''), 5000);
                    return;
                }
                
                // Clear any existing validation message
                setValidationMessage('');
                
                // For simple placeholders, wrap in curly braces
                const placeholderText = `{${placeholderPath}}`;
                editorInstance.model.change(writer => {
                    const selection = editorInstance.model.document.selection;
                    const range = selection.getFirstRange();
                    writer.insertText(placeholderText, range.start);
                });
            }
        }
    }

    const handlePlaceholderDragStart = (e, placeholderPath) => {
        // Check if this is a Django template loop
        const placeholderText = placeholderPath.includes('{% for') 
            ? placeholderPath 
            : `{${placeholderPath}}`;
        e.dataTransfer.setData('text/plain', placeholderText);
        e.dataTransfer.effectAllowed = 'copy';
    }

    const handleEditorDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    }

    const validateLoopVariable = (variableText, editorContent) => {
        // Check if the variable is a loop variable (contains _loop.)
        const cleanText = variableText.replace(/[{}]/g, '');
        const loopVarMatch = cleanText.match(/^([^}]+_loop)\./);
        if (!loopVarMatch) return { valid: true }; // Not a loop variable, always valid
        
        const loopVar = loopVarMatch[1];
        
        // Check if there's a matching loop for this variable in the editor content
        const loopPattern = new RegExp(`{%\\s+for\\s+${loopVar.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s+in\\s+[^%]+%}`, 'g');
        const loopMatches = [...editorContent.matchAll(loopPattern)];
        
        if (loopMatches.length === 0) {
            return { valid: false, message: `Variable ${variableText} requires a matching loop for ${loopVar}. Please create the loop first.` };
        }
        
        return { valid: true };
    };

    return (
        <div
            id={`wrapper-${fieldName}`}
            className={`ckeditor form-group ${errors.length > 0 ? 'has-error is-invalid' : ''} ${wrapperClass}`}
            name={fieldName}
        >
            <label className="form-check-label col-form-label w-100" htmlFor={fieldName}>
                {label} {!allowNull && '*'}
            </label>
            <div className="ckeditor-wrapper border rounded p-0 overflow-hidden d-flex">
                <div className="d-flex flex-column gap-1 w-100">
                    {placeholders.length > 0 && (
                        <div className="placeholder-toolbar p-2 border-bottom ">
                            <small className="text-muted mb-2 d-block">{i18n.t('Drag placeholders')}:</small>
                            <PlaceholderSelector
                                placeholders={placeholders}
                                onSelect={insertPlaceholder}
                                onDragStart={handlePlaceholderDragStart}
                            />
                        </div>
                    )}
                    <div
                        onDragOver={handleEditorDragOver}
                    >
                        <CKEditor
                            id={pk ? pk + '_' + fieldName : fieldName}
                            editor={ClassicEditor}
                            data={value || ''}
                            className={`form-control ${errors.length > 0 ? 'border border-danger' : ''}`}
                            onReady={editor => {
                                setEditorInstance(editor);
                                // Add drop event listener to the editor
                                editor.editing.view.document.on('drop', (evt, data) => {
                                    const dataTransfer = data.dataTransfer;
                                    const placeholderText = dataTransfer.getData('text/plain');
                                    
                                    if (placeholderText && placeholderText.includes('_loop.')) {
                                        // Validate loop variables
                                        const validation = validateLoopVariable(placeholderText, editor.getData());
                                        if (!validation.valid) {
                                            evt.stop();
                                            setValidationMessage(validation.message);
                                            setTimeout(() => setValidationMessage(''), 5000);
                                            return;
                                        }
                                        
                                        // Clear any existing validation message
                                        setValidationMessage('');
                                    }
                                });
                            }}
                            onBlur={(event, editor) => {
                                localOnChange(event, editor)
                            }}
                            onFocus={(event, editor) => {

                            }}
                        />
                    </div>
                </div>
            </div>
            {validationMessage && (
                <div className="alert alert-warning alert-dismissible fade show mt-2" role="alert">
                    <small>{validationMessage}</small>
                    <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setValidationMessage('')}
                        aria-label="Close"
                    ></button>
                </div>
            )}
            {errors ? errors.map((error, index) => <FieldError key={index} error={error} />) : null}
            <HelpText helpText={helpText} />
        </div>
    );
}

export default CkEditor;